import api from './api';

function authHeaders() {
	const token = localStorage.getItem('companyToken');
	return token ? { Authorization: `Bearer ${token}` } : {};
}

export async function createJob(data) {
	const res = await api.post('/company/jobs', data, { headers: authHeaders() });
	return res.data;
}

export async function getCompanyJobs(params = {}) {
	const res = await api.get('/company/jobs', { params, headers: authHeaders() });
	return res.data;
}

export async function getJobById(id) {
	const res = await api.get(`/company/jobs/${id}`, { headers: authHeaders() });
	return res.data;
}

export async function updateJob(id, data) {
	const res = await api.put(`/company/jobs/${id}`, data, { headers: authHeaders() });
	return res.data;
}

export async function deleteJob(id) {
	const res = await api.delete(`/company/jobs/${id}`, { headers: authHeaders() });
	return res.data;
}

export async function getJobAnalytics(id) {
	const res = await api.get(`/company/jobs/${id}/analytics`, { headers: authHeaders() });
	return res.data;
}


